import '../../../define/i18n';
import '../../../define/ui/container';
import '../../../define/ui/poster';
import '../../../define/ui/buffering-indicator';
import '../../../define/ui/error-dialog';
import '../../../define/ui/dialog-backdrop';
import '../../../define/ui/dialog-popup';
import '../../../define/ui/dialog-title';
import '../../../define/ui/dialog-description';
import '../../../define/ui/dialog-close';
import '../../../define/ui/title';
import '../../../define/ui/controls';
import '../../../define/ui/controls-backdrop';
import '../../../define/ui/controls-content';
import '../../../define/ui/tooltip-group';
import '../../../define/ui/controls-group';
import '../../../define/ui/play-button';
import '../../../define/ui/tooltip';
import '../../../define/ui/tooltip-label';
import '../../../define/ui/tooltip-shortcut';
import '../../../define/ui/mute-button';
import '../../../define/ui/volume-popover';
import '../../../define/ui/volume-slider';
import '../../../define/ui/slider-track';
import '../../../define/ui/slider-fill';
import '../../../define/ui/slider-thumb';
import '../../../define/ui/time';
import '../../../define/ui/time-slider';
import '../../../define/ui/time-slider-chapters';
import '../../../define/ui/slider-buffer';
import '../../../define/ui/slider-preview';
import '../../../define/ui/slider-thumbnail';
import '../../../define/ui/time-slider-chapter-title';
import '../../../define/ui/slider-value';
import '../../../define/ui/captions-button';
import '../../../define/ui/menu';
import '../../../define/ui/menu-content';
import '../../../define/ui/menu-item';
import '../../../define/ui/menu-separator';
import '../../../define/ui/quality-radio-group';
import '../../../define/ui/menu-radio-item';
import '../../../define/ui/menu-item-indicator';
import '../../../define/ui/audio-track-radio-group';
import '../../../define/ui/playback-rate-radio-group';
import '../../../define/ui/captions-radio-group';
import '../../../define/ui/cast-button';
import '../../../define/ui/airplay-button';
import '../../../define/ui/pip-button';
import '../../../define/ui/fullscreen-button';
import '../../../define/ui/hotkey';
import '../../../define/ui/gesture';
import '../../../define/ui/status-announcer';
import '../../../define/ui/volume-indicator';
import '../../../define/ui/volume-indicator-fill';
import '../../../define/ui/volume-indicator-value';
import '../../../define/ui/status-indicator';
import '../../../define/ui/status-indicator-value';
import '../../../define/ui/seek-indicator';
import '../../../define/ui/seek-indicator-value';
import { registerIcons } from '../../../icons';
import {
  airPlayEnterIcon,
  airPlayExitIcon,
  captionsOffIcon,
  captionsOnIcon,
  castEnterIcon,
  castExitIcon,
  checkIcon,
  chevronIcon,
  fullscreenEnterIcon,
  fullscreenExitIcon,
  gearIcon,
  pauseIcon,
  pipEnterIcon,
  pipExitIcon,
  playIcon,
  restartIcon,
  speechIcon,
  speedIcon,
  spinnerIcon,
  switchesIcon,
  volumeHighIcon,
  volumeLowIcon,
  volumeOffIcon,
} from '../../../icons';

registerIcons('default', {
  'airplay-enter': airPlayEnterIcon,
  'airplay-exit': airPlayExitIcon,
  'captions-off': captionsOffIcon,
  'captions-on': captionsOnIcon,
  'cast-enter': castEnterIcon,
  'cast-exit': castExitIcon,
  check: checkIcon,
  chevron: chevronIcon,
  'fullscreen-enter': fullscreenEnterIcon,
  'fullscreen-exit': fullscreenExitIcon,
  gear: gearIcon,
  pause: pauseIcon,
  'pip-enter': pipEnterIcon,
  'pip-exit': pipExitIcon,
  play: playIcon,
  restart: restartIcon,
  speech: speechIcon,
  speed: speedIcon,
  spinner: spinnerIcon,
  switches: switchesIcon,
  'volume-high': volumeHighIcon,
  'volume-low': volumeLowIcon,
  'volume-off': volumeOffIcon,
});
